import React from 'react'

import { logos } from './const/logos'
import { styles } from './styles'
import { makeStyles } from '@material-ui/core/styles'

export const CompanyTrustSections = () => {
  const useStyles = makeStyles(styles)
  const classes = useStyles()

  return (
    <div className={classes.container}>
      <p className={classes.text}>Trusted by</p>

      <div className={classes.logosWrapper}>
        {logos.map(({ Icon, id }) => (
          <div className={classes.logo} key={id}>
            <Icon fill="#2E3860" height="35" width="200" />
          </div>
        ))}
      </div>
    </div>
  )
}
